import React from 'react';
import Card from '../../elements/ReactBootstrap/Card';
import {Col, Row} from 'react-bootstrap';
import {useCreateTravelAssistanceApplicationMutation} from '../../../features/apiSlice';
import ErrorWidget from '../../widgets/ErrorWidget';
import {useNavigate, useParams} from 'react-router-dom';
import Content from '../../partials/Content.jsx';
import SmallSpinner from '../../elements/Spinner/SmallSpinner.jsx';
import TravelAssistanceOfferWidget from "../../widgets/TravelAssistance/TravelAssistanceOfferWidget.jsx";
import TravelAssistanceOfferWidgetAdditionalInformation
    from "../../widgets/TravelAssistance/TravelAssistanceOfferWidgetAdditionalInformation.jsx";

const TravelAssistanceApplication = () => {
    const [createApplication, {
        error,
        isLoading,
        isError,
    }] = useCreateTravelAssistanceApplicationMutation();

    const navigate = useNavigate();
    const {action} = useParams();

    return (<Content title="Оферта за нова полица Помощ при пътуване">
        <Row className="row-cols-1">
            <TravelAssistanceOfferWidget autoFocus={true} autoSubmit={action === 'find'} onSubmit={async values => {
                // alert(JSON.stringify(values));
                navigate('/travel/new', {
                    replace: true,
                });

                const application = await createApplication(values).unwrap();
                navigate('/travel/new/application/' + application.id);
            }}>
                <TravelAssistanceOfferWidgetAdditionalInformation />
            </TravelAssistanceOfferWidget>
        </Row>
        <Row>
            <Col>
                {isLoading && <Card>
                    Проверка на данните за тарифиране... <SmallSpinner />
                </Card>}
                {isError && <ErrorWidget error={error} />}
            </Col>
        </Row>
    </Content>);
};

export default TravelAssistanceApplication;
